angular
    .module("skillBuilderSaaS")
    .directive("autofocus", (["$timeout", function ($timeout) {
        return {
            restrict: "A",
            link: function (_scope, element) {
                $timeout(function () {
                    element[0].focus();
                }, 50); //time needed for modals
            }
        };
    }]));
